module.exports = __webpack_public_path__ + "static/media/CelularCryptos2.848e9c25.png";